export const USER = 'user'
export const TOKEN = 'token'
